import React, { useEffect, useState } from "react";
import SliderContent from "./Imagecontent";
import Dots from "./SliderDot";
import Arrows from "./sliderarrow";
import { bankData } from "./Homeimage";
import "./home.css";


import { RiLineChartLine, RiMoneyDollarCircleLine, RiBankCardLine, RiStoreLine, RiCustomerService2Line } from 'react-icons/ri'
import { FaCcVisa } from 'react-icons/fa';

const len = bankData.length - 1;
function Home(props) {
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex(activeIndex === len ? 0 : activeIndex + 1);
    }, 3000);
    return () => clearInterval(interval);
  }, [activeIndex]);

  return (
    <div>
      <div className="slider-container">
        <SliderContent activeIndex={activeIndex} sliderImage={bankData} />
        <Arrows
          prevSlide={() => setActiveIndex(activeIndex < 1 ? len : activeIndex - 1)}
          nextSlide={() => setActiveIndex(activeIndex === len ? 0 : activeIndex + 1)} />
        <Dots
          activeIndex={activeIndex}
          sliderImage={bankData}
          onclick={(activeIndex) => setActiveIndex(activeIndex)} />
      </div>
      <div className="row">
        <div align='center'> <h2 style={{ color: 'red', fontWeight: 'bold' }}>Services we Offer</h2> </div>
        <div className="services-container">
          <div className="service-item">
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70px' }}>
              <RiMoneyDollarCircleLine size={48} style={{ color: '#cc3333' }} />
            </div>
            <h2 className="ServiceTitle" align='center'>Savings Account</h2>

          </div>
          <div className="service-item">
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70px' }}>
              <RiBankCardLine size={48} style={{ color: '#cc3333' }} />
            </div>
            <h2 align='center'>Checking Account</h2>

          </div>
          <div className="service-item">
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70px' }}>
              <FaCcVisa size={48} style={{ color: '#cc3333' }} />
            </div>
            <h2 align='center' >Credit Cards</h2>

          </div>
          <div className="service-item">
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70px' }}>
              <RiStoreLine size={48} style={{ color: '#cc3333' }} />
            </div>
            <h2 align='center'>Merchant Account</h2>

          </div>
          <div className="service-item">
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70px' }}>

              <RiCustomerService2Line size={48} style={{ color: '#cc3333' }} />
            </div>
            <h2 align='center'>Customer Service</h2>

          </div>
          <div className="service-item">
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70px' }}>
              <RiLineChartLine size={48} style={{ color: '#cc3333' }} />

            </div>
            <h2 align='center'>Investment</h2>
          </div>
        </div>
      </div>
    </div>



  );
}

export default Home;